"use strict";
"use client";
import { chakra } from '../../styled-system/factory.js';

const Em = chakra("em", {
  base: {
    fontStyle: "italic"
  }
});

export { Em };
